import { createReducer } from "@reduxjs/toolkit";
import type { ProcessingState } from "@redux/state/shared-types";
import { requestCollaboration, resetRequestCollaboration } from "./request-collaboration";

const initialState: ProcessingState = { processing: "idle" };

export const requestCollaborationReducer = createReducer<ProcessingState>(initialState, builder => {
  builder.addCase(requestCollaboration.fulfilled, state => {
    return {
      ...state,
      processing: "success",
    };
  });
  builder.addCase(requestCollaboration.pending, state => {
    return {
      ...state,
      processing: "pending",
    };
  });
  builder.addCase(requestCollaboration.rejected, state => {
    return {
      ...state,
      processing: "failed",
    };
  });
  builder.addCase(resetRequestCollaboration, () => {
    return initialState;
  });
});
